import { cloneDeep, get } from 'lodash';
import { combineReducers } from 'redux';
import * as SagasType from '../../constants/constant_saga_types';

const INIT_STATE = {
  create: null,
  data: null,
  edit: null,
  fetchError: '',
  isCreate: false,
  isEditMode: false,
  isFetching: false,
  isSaveSuccess: false,
  isSaving: false,
  isSelecting: false,
  isSelectSilent: false,
  saveError: '',
  selectError: '',
};

function dashboardDataReducer(state = INIT_STATE, action) {
  const mode = state.isEditMode ? 'edit' : 'data';

  switch (action.type) {
    case SagasType.FETCH_DASHBOARD_INPROGRESS:
      return { ...INIT_STATE, isFetching: true };

    case SagasType.FETCH_DASHBOARD_ERROR:
      return { ...INIT_STATE, fetchError: action.payload };

    case SagasType.FETCH_DASHBOARD_DONE:
      return {
        ...INIT_STATE,
        data: action.payload,
      };

    case SagasType.SAVE_DASHBOARD_INPROGRESS:
      return {
        ...state,
        isSaveSuccess: false,
        isSaving: true,
        saveError: '',
      };

    case SagasType.SAVE_DASHBOARD_ERROR:
      return {
        ...state,
        isSaveSuccess: false,
        isSaving: false,
        saveError: action.payload,
      };

    case SagasType.SAVE_DASHBOARD_DONE:
      return {
        ...state,
        ...action.payload,
        create: null,
        isCreate: false,
        isSaveSuccess: true,
        isSaving: false,
      };

    case SagasType.EDIT_DASHBOARD:
      return {
        ...state,
        create: null,
        edit: action.payload ? cloneDeep(state.data) : null,
        isCreate: false,
        isEditMode: action.payload,
      };

    case SagasType.RESET_EDIT_DASHBOARD_DONE:
      return {
        ...state,
        edit: state.isCreate ? cloneDeep(state.create) : cloneDeep(state.data),
      };

    case SagasType.CREATE_DASHBOARD_DONE:
      return {
        ...state,
        ...action.payload,
        isCreate: true,
        isEditMode: true,
      };

    case SagasType.CHANGE_DASHBOARD_DATA:
      return {
        ...state,
        [mode]: {
          ...state[mode],
          ...action.payload,
        },
      };

    case SagasType.SET_DASHBOARD: {
      const { isHome, isSilent } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: isHome ? false : state.isSelecting,
        isSelectSilent: isHome ? isSilent : state.isSelectSilent,
        selectError: isHome ? '' : state.selectError,
      };
    }
    
    case SagasType.SET_DASHBOARD_ERROR: {
      const { isHome, error } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: isHome ? false : state.isSelecting,
        isSelectSilent: isHome ? false : state.isSelectSilent,
        selectError: isHome ? error : state.selectError,
      };
    }

    case SagasType.SET_DASHBOARD_DONE: {
      const { isHome } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: isHome ? false : state.isSelecting,
        isSelectSilent: isHome ? false : state.isSelectSilent,
        selectError: isHome ? '' : state.selectError,
      };
    }

    default:
      return state;
  }
}

const INIT_STATE_DASHBOARD_PORTLET_META = {
  data: null,
  isFetching: false,
  isSettingUp: false,
  limit: 10,
  offset: 0,
  setupError: '',
  fetchError: '',
};

function dashboardPortletsMetaReducer(state = {}, action) {
  switch (action.type) {
    case SagasType.CLEAR_PORTLET_ERROR:
    case SagasType.EXECUTE_DASHBOARD_PORTLET:
    case SagasType.FETCH_DASHBOARD_PORTLET_DONE:
    case SagasType.FETCH_DASHBOARD_PORTLET_ERROR:
    case SagasType.FETCH_DASHBOARD_PORTLET_INPROGRESS:
    case SagasType.INIT_DASHBOARD_PORTLET_META:
    case SagasType.SETUP_PORTLET_DONE:
    case SagasType.SETUP_PORTLET_ERROR:
    case SagasType.SETUP_PORTLET:
      return {
        ...state,
        [action.payload.id]: dashboardPortletMetaReducer(
          state[action.payload.id],
          action
        ),
      };

    case SagasType.DELETE_PORTLET_META:
      return {
        ...state,
        [action.payload]: undefined,
      };

    default:
      return state;
  }
}

function dashboardPortletMetaReducer(
  state = INIT_STATE_DASHBOARD_PORTLET_META,
  action
) {
  switch (action.type) {
    case SagasType.INIT_DASHBOARD_PORTLET_META:
      return { ...state };

    case SagasType.FETCH_DASHBOARD_PORTLET_DONE:
      return {
        ...state,
        error: '',
        isFetching: false,
        isSilent: false,
        data: action.payload.data,
      };

    case SagasType.FETCH_DASHBOARD_PORTLET_ERROR:
      return {
        ...state,
        isFetching: false,
        fetchError: action.payload.error,
      };

    case SagasType.FETCH_DASHBOARD_PORTLET_INPROGRESS:
      return {
        ...state,
        fetchError: '',
        isFetching: true,
      };

    case SagasType.SETUP_PORTLET:
      return {
        ...state,
        isSettingUp: true,
        setupError: '',
      };

    case SagasType.SETUP_PORTLET_DONE:
      return {
        ...state,
        isSettingUp: false,
        setupError: '',
      };

    case SagasType.SETUP_PORTLET_ERROR:
      return {
        ...state,
        isSettingUp: false,
        setupError: action.payload.error,
      };

    case SagasType.EXECUTE_DASHBOARD_PORTLET:
      return {
        ...state,
        isSilent: action.payload.isSilent,

        limit:
          action.payload.limit !== undefined
            ? action.payload.limit
            : state.limit,

        offset:
          action.payload.offset !== undefined
            ? action.payload.offset
            : state.offset,
      };

    case SagasType.CLEAR_PORTLET_ERROR: {
      return {
        ...state,
        fetchError: '',
      }
    }

    default:
      return state;
  }
}

const INIT_STATE_LIST = {
  deleteError: '',
  fetchError: '',
  isDeleteSuccess: false,
  isDeleting: false,
  isFetching: false,
  isFetchSilent: false,
  isSelecting: false,
  list: null,
  searchTerm: '',
  selectError: '',
};

function dashboardListReducer(state = INIT_STATE_LIST, action) {
  switch (action.type) {
    case SagasType.DELETE_DASHBOARD:
      return {
        ...state,
        deleteError: '',
        isDeleteSuccess: false,
        isDeleting: true,
      };

    case SagasType.DELETE_DASHBOARD_ERROR:
      return {
        ...state,
        deleteError: action.payload,
        isDeleting: false,
      };

    case SagasType.DELETE_DASHBOARD_DONE:
      return {
        ...state,
        isDeleteSuccess: true,
        isDeleting: false,
        list: action.payload,
      };

    case SagasType.FETCH_DASHBOARD_LIST:
      return {
        ...state,
        fetchError: '',
        isFetching: true,
        isFetchSilent: get(action, 'payload.isSilent', false),
        searchTerm: get(action, 'payload.searchTerm', ''),
      };

    case SagasType.FETCH_DASHBOARD_LIST_ERROR:
      return {
        ...state,
        fetchError: action.payload,
        isFetching: false,
        isFetchSilent: false,
      };

    case SagasType.FETCH_DASHBOARD_LIST_DONE:
      return {
        ...state,
        isFetching: false,
        isFetchSilent: false,
        list: action.payload,
      };

    case SagasType.CLEAR_FETCH_DASHBOARD_LIST_ERROR:
      return {
        ...state,
        fetchError: '',
        deleteError: '',
        saveError: '',
      };

    case SagasType.SET_DASHBOARD: {
      const { isHome } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: !isHome ? true : state.isSelecting,
        selectError: !isHome ? '' : state.selectError,
      };
    }

    case SagasType.SET_DASHBOARD_ERROR: {
      const { isHome, error } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: !isHome ? false : state.isSelecting,
        selectError: !isHome ? error : state.selectError,
      };
    }

    case SagasType.SET_DASHBOARD_DONE: {
      const { isHome } = get(action, 'payload', {});
      return {
        ...state,
        isSelecting: !isHome ? false : state.isSelecting,
        selectError: !isHome ? false : state.selectError,
      };
    }

    default:
      return state;
  }
}

const reducers = combineReducers({
  list: dashboardListReducer,
  dashboard: dashboardDataReducer,
  portlets_meta: dashboardPortletsMetaReducer,
});

export const dashboardReducer = (state, action) => {
  return reducers(state, action);
};
